import script from "./FrequencyStartSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./FrequencyStartSettings.vue?vue&type=script&setup=true&lang=js"

import "./FrequencyStartSettings.vue?vue&type=style&index=0&id=534071a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-534071a6"]])

export default __exports__